import { useSelector, useDispatch } from "react-redux";
import {
  updateQuantity,
  removeFromCart,
  clearCart,
} from "../Redux/cart/cartSlice";
import Navbar from "../components/Navbar";
import { Trash2Icon, TruckIcon } from "lucide-react";

const Cart = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);

  const totalPrice = cartItems.reduce(
    (acc, item) => acc + item.finalPrice * item.quantity,
    0
  );

  return (
    <div className="container mx-auto  ">
      <Navbar />
      <div className="bg-slate-100 h-screen p-6 mx-2">
        <h2 className="text-3xl font-bold mb-4 pl-6">Shopping Cart</h2>

        {cartItems.length === 0 ? (
          <p className="text-gray-600 pl-6 ">Your cart is empty.</p>
        ) : (
          <div className="flex justify-around items-center flex-wrap">
            <div className="grid gap-4  max-w-[60%] ">
              {cartItems.map((item) => (
                <div
                  key={item.id}
                  className="flex items-center gap-6 border p-4 rounded-lg shadow bg-white"
                >
                  <img
                    src={item.images[0]}
                    alt={item.name}
                    className="w-24 h-24 object-cover rounded object-center"
                  />
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold">{item.name}</h3>
                    <p className="text-gray-500">{item.description}</p>
                    <p className="font-bold text-lg ">
                      ${item.finalPrice} x {item.quantity}
                    </p>
                  </div>

                  {/* Quantity Selector */}
                  <div className="flex items-center">
                    <button
                      className="px-3 py-1 border rounded bg-gray-200"
                      onClick={() =>
                        dispatch(
                          updateQuantity({
                            id: item.id,
                            quantity: item.quantity - 1,
                          })
                        )
                      }
                      disabled={item.quantity <= 1}
                    >
                      -
                    </button>
                    <span className="px-4">{item.quantity}</span>
                    <button
                      className="px-3 py-1 border rounded bg-gray-200"
                      onClick={() =>
                        dispatch(
                          updateQuantity({
                            id: item.id,
                            quantity: item.quantity + 1,
                          })
                        )
                      }
                    >
                      +
                    </button>
                  </div>

                  {/* Remove Button */}
                  <button
                    className="px-4 py-2 bg-red-500 text-white rounded"
                    onClick={() => dispatch(removeFromCart(item.id))}
                  >
                    <Trash2Icon />
                  </button>
                </div>
              ))}
            </div>

            <div className="mt-6 flex gap-4 flex-col items-center justify-end bg-white w-[400px] p-2">
              <h2 className="uppercase bg-slate-100/80 px-2 py-2 w-[100%] font-bold text-xs text-gray-500 rounded-2xl mt-2 ">
                Order Summary
              </h2>
              <p className="italic text-xs">
                Shipping and addditional costs are calculated based on values
                you have entered
              </p>
              <div className="w-[100%]">
                <h3 className="text-md text-gray-500 text-sm font-bold flex justify-between w-[100%]">
                  Order SubTotal{" "}
                  <div className="text-black/80">${totalPrice.toFixed(2)}</div>
                </h3>
                <p className="w-[100%] h-[1px] bg-gray-500 mt-2"></p>
              </div>
              <div className="w-[100%]">
              <h3 className="text-md text-gray-500 text-sm font-bold flex justify-between w-[100%]">
                Shipping and handling{" "}
                <div className="text-black/80">$10.00</div>
              </h3>
              <p className="w-[100%] h-[1px] bg-gray-500 mt-2"></p>
              </div>
              <h3 className="text-md text-gray-500 text-sm font-bold flex justify-between w-[100%]">
                Total <div className="text-black/80">${totalPrice+10}</div>
              </h3>
              <button className="bg-violet-600 pt-3 pb-3 pl-5 text-black pr-5 text-[18px] rounded-md  mr-4 hover:bg-violet-800 flex items-center gap-2">
                Proceed To Payment  <TruckIcon className=" text-black"/>
              </button>
              <button
                className="px-5 py-3 bg-red-500/90 hover:bg-red-500 text-white rounded"
                onClick={() => dispatch(clearCart())}
              >
                Clear Cart
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Cart;
